export default "__VITE_ASSET__l$WY4znS__"